import { createClient } from '@/api-client'
import { SubscriptionSchedules } from '@/api-client/SubscriptionSchedules'
import { Subscriptions } from '@/api-client/Subscriptions'
import { HeaderNav } from '~/components/subscription/rose-lp/header-nav'
import { HeroSection } from '~/components/subscription/rose-lp/hero-section'
import { IntroSection } from '~/components/subscription/rose-lp/intro-section'
import { VisualBreak } from '~/components/subscription/rose-lp/visual-break'
import { FeaturesSection } from '~/components/subscription/rose-lp/features-section'
import { PlannedMaterialEntry } from '~/components/subscription/rose-plan-card'
import { DeliveredRosesSection } from '~/components/subscription/rose-lp/delivered-roses-section'
import { ReasonSection } from '~/components/subscription/rose-lp/reason-section'
import { PricingSection } from '~/components/subscription/rose-lp/pricing-section'
import { VasesSection } from '~/components/subscription/rose-lp/vases-section'
import { InterviewSection } from '~/components/subscription/rose-lp/interview-section'
import { AboutSection } from '~/components/subscription/rose-lp/about-section'
import { FaqSection } from '~/components/subscription/rose-lp/faq-section'
import { TailSection } from '~/components/subscription/rose-lp/tail-section'
import { Footer } from '~/components/subscription/rose-lp/footer'
import { BottomBar } from '~/components/subscription/rose-lp/bottom-bar'
import { DesktopHero } from '~/components/subscription/rose-lp/desktop-hero'
import { DesktopSidebar } from '~/components/subscription/rose-lp/desktop-sidebar'

async function fetchSchedules() {
  return createClient(SubscriptionSchedules).getSubscriptionSchedules({ upcoming: '1', category: 'rose' })
}

function fetchDeliveredCultivars() {
  return createClient(Subscriptions).getSubscriptionsDeliveredCultivars({ category: 'rose' })
}

const deliveredCultivars = fetchDeliveredCultivars()
  .then((json) => json.data)
  .catch(() => ({ data: [] }))

function fetchInBulkPurchasables() {
  return createClient(Subscriptions).getSubscriptionsInBulkPurchasables({ category: 'rose' })
}

const inBulkPurchasables = fetchInBulkPurchasables()
  .then((json) => json.data.data)
  .catch(() => [])

function fetchPlannedMaterials() {
  return createClient(Subscriptions).getSubscriptionsPlannedMaterials({ category: 'rose' })
}

const plannedMaterialEntries = fetchPlannedMaterials()
  .then((json) => (json.data.data?.attributes?.entries ?? []) as unknown as PlannedMaterialEntry[])
  .catch(() => [] as PlannedMaterialEntry[])

const deliveryRange = fetchSchedules()
  .then((json) => {
    return json.data.data[0].attributes.deliver_at
      .map((ts) => new Date(ts * 1000))
      .map((date) => `${date.getMonth() + 1}/${date.getDate()}`)
      .join('〜')
  })
  .catch(() => '')

export const SubscriptionRose: React.FC = () => {
  return (
    <div className="page-enter font-display text-main" id="top">
      <div className="flex items-start">
        <DesktopHero />

        {/* 中央カラム。overflow-hiddenを付けるとBottomBarのstickyが効かなくなるので注意 */}
        <div className="w-full lg:w-[45%] bg-white min-h-screen relative">
          <HeaderNav />
          <div>
            <HeroSection />
            <div id="roses">
              <IntroSection />
            </div>
            <VisualBreak image="a">
              バラは世界に3万種以上。
              <br />
              今も新しい品種が生まれ続けています。
            </VisualBreak>
            <FeaturesSection plannedMaterialEntries={plannedMaterialEntries} />
            <DeliveredRosesSection deliveredCultivars={deliveredCultivars} />
            <ReasonSection />
            <PricingSection />
            <div id="vases">
              <VasesSection inBulkPurchasables={inBulkPurchasables} />
            </div>
            <InterviewSection />
            <VisualBreak image="b" />
            <AboutSection />
            <FaqSection />
            <TailSection />
            <Footer />
            <BottomBar deliveryRange={deliveryRange} />
          </div>
        </div>

        <DesktopSidebar />
      </div>
    </div>
  )
}
